<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="scrollableCols"
          [value]="eventsDisplayed"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="550px"
          dataKey="m365eventId"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          [totalRecords]="totalRecords"
          [lazy]="true"
          (onLazyLoad)="this.loadEvents($any($event))"
          (onFilter)="applyFilter($event)"
          exportFilename="M365EventRecords">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <input
                type="text"
                pInputText
                size="30"
                placeholder="Search"
                (keyup)="
                  eventSearchFilterRequest.searchString = $any(
                    $event.target
                  ).value
                "
                [(ngModel)]="eventSearchFilterRequest.searchString"
                (input)="onSearchInput($event, dt)"
                style="width: auto"
                [value]="
                  dt.filters['global'] ? $any(dt.filters['global']).value : ''
                " />
              <i class="fa fa-search ml-2"></i>
              <span class="pageInfo visiblelg resettble">{{
                currentPageInfo
              }}</span>
              <span style="float: right; position: relative; top: 12px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header>
            <tr class="row">
              <th
                [pSortableColumn]="'eventKey'"
                (click)="sort('eventKey')"
                class="colsmall">
                {{ isMrppCustomerValidationReviewScreen ? 'EID' : 'Event ID' }}
                <p-sortIcon [field]="'eventKey'"></p-sortIcon>
              </th>
              @if (
                eventSearchType ===
                  skuPurchaseTrialActivationReviewEventSearchType ||
                eventSearchType === customerValidationReviewEventSearchType ||
                eventSearchType === invoiceDocReviewEventSearchType ||
                eventSearchType === rollCallReviewEventSearchType ||
                eventSearchType === customerSurveyReviewEventSearchType ||
                eventSearchType === daPOEReviewEventSearchType ||
                eventSearchType === SOWReviewEventSearchType
              ) {
                <th [pSortableColumn]="'eventId'" class="colsmall">Preview</th>
              }
              <th [pSortableColumn]="'eventName'" (click)="sort('eventName')">
                Workshop Type<p-sortIcon [field]="'eventName'"></p-sortIcon>
              </th>
              @if (showTargetProduct) {
                <th [pSortableColumn]="'eventId'">Target Product</th>
              }
              <th
                [pSortableColumn]="'partnerOrgName'"
                (click)="sort('partnerOrgName')"
                class="colmedium">
                Partner Org<p-sortIcon [field]="'partnerOrgName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'fiscalYear'">
                Fiscal Year<p-sortIcon [field]="'fiscalYear'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'l1InternalStatus'"
                (click)="sort('l1InternalStatus')">
                L1 Internal Status<p-sortIcon
                  [field]="'l1InternalStatus'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'l2InternalStatus'"
                (click)="sort('l2InternalStatus')">
                L2 Internal Status<p-sortIcon
                  [field]="'l2InternalStatus'"></p-sortIcon>
              </th>
              @if (
                eventSearchType === invoiceDocReviewEventSearchType ||
                eventSearchType === rollCallReviewEventSearchType ||
                eventSearchType ===
                  skuPurchaseTrialActivationReviewEventSearchType ||
                eventSearchType === daPOEReviewEventSearchType ||
                eventSearchType === SOWReviewEventSearchType
              ) {
                <th
                  [pSortableColumn]="'poeDocUploadDate'"
                  (click)="sort('poeDocUploadDate')">
                  Uploaded Date<p-sortIcon
                    [field]="'poeDocUploadDate'"></p-sortIcon>
                </th>
              }
              @if (eventSearchType === customerSurveyReviewEventSearchType) {
                <th
                  [pSortableColumn]="'submittedDate'"
                  (click)="sort('submittedDate')">
                  Submitted Date<p-sortIcon
                    [field]="'submittedDate'"></p-sortIcon>
                </th>
              }
            </tr>
            @if (!isMrppCustomerValidationReviewScreen) {
              <tr class="row">
                <th></th>
                <th></th>
                <th class="dashtable">
                  <p-multiSelect
                    [options]="eventTypeDropdownItems"
                    appendTo="body"
                    placeholder="Event Sub Type"
                    [(ngModel)]="eventSearchFilterRequest.eventType"
                    (onChange)="searchOrFilterEngagements()"></p-multiSelect>
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            }
          </ng-template>
          <ng-template #body let-rowData>
            <tr
              (dblclick)="editRequestDetails(rowData.eventRegistrationId)"
              class="row">
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }}">
                  <a
                    (click)="editRequestDetails(rowData.eventRegistrationId)"
                    (keydown.enter)="
                      editRequestDetails(rowData.eventRegistrationId)
                    "
                    tabindex="0"
                    class="editlink"
                    >{{ rowData.eventRegistrationId }}</a
                  >
                </span>
              </td>
              @if (
                eventSearchType === customerValidationReviewEventSearchType
              ) {
                <td class="colsmall">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.eventRegistrationId }} : {{
                      rowData.eventRegistrationId
                    }}">
                    <a
                      class="editlink"
                      (click)="
                        showCustomerValidationPreview(
                          rowData.eventRegistrationId
                        )
                      "
                      (keydown.enter)="
                        showCustomerValidationPreview(
                          rowData.eventRegistrationId
                        )
                      "
                      tabindex="0"
                      >Preview</a
                    >
                  </span>
                </td>
              }
              @if (eventSearchType === customerSurveyReviewEventSearchType) {
                <td class="colsmall">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.eventRegistrationId }} : {{
                      rowData.eventRegistrationId
                    }}">
                    <a
                      class="editlink"
                      (click)="
                        showCustomerSurveyPreview(rowData.eventRegistrationId)
                      "
                      (keydown.enter)="
                        showCustomerSurveyPreview(rowData.eventRegistrationId)
                      "
                      tabindex="0"
                      >Preview</a
                    >
                  </span>
                </td>
              }
              @if (
                eventSearchType ===
                  skuPurchaseTrialActivationReviewEventSearchType ||
                eventSearchType === rollCallReviewEventSearchType ||
                eventSearchType === daPOEReviewEventSearchType ||
                eventSearchType === SOWReviewEventSearchType
              ) {
                <td class="colsmall">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.eventRegistrationId }} : {{
                      rowData.eventRegistrationId
                    }}">
                    <a
                      class="editlink"
                      (click)="previewFile(rowData.eventRegistrationId)"
                      (keydown.enter)="previewFile(rowData.eventRegistrationId)"
                      tabindex="0"
                      >Preview</a
                    >
                  </span>
                </td>
              }
              @if (eventSearchType === invoiceDocReviewEventSearchType) {
                <td class="colsmall">
                  @if (rowData.isDisablePreview) {
                    <span>Preview</span>
                  }
                  @if (!rowData.isDisablePreview) {
                    <span
                      tooltipPosition="top"
                      pTooltip="{{ rowData.eventRegistrationId }} : {{
                        rowData.eventRegistrationId
                      }}">
                      <a
                        class="editlink"
                        (click)="previewFile(rowData.eventRegistrationId)"
                        (keydown.enter)="
                          previewFile(rowData.eventRegistrationId)
                        "
                        tabindex="0"
                        >Preview</a
                      >
                    </span>
                  }
                </td>
              }
              <td>
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.eventName
                  }}"
                  >{{ rowData.eventName }}</span
                >
              </td>
              @if (showTargetProduct) {
                <td>
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.eventRegistrationId }} : {{
                      rowData.eventTargetProductName
                    }}"
                    >{{ rowData.eventTargetProductName }}</span
                  >
                  @if (!rowData.eventTargetProductName) {
                    <span>NA</span>
                  }
                </td>
              }
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.partnerOrgName
                  }}"
                  >{{ rowData.partnerOrgName }}</span
                >
              </td>
              <td>
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.fiscalYear
                  }}"
                  >{{ rowData.fiscalYear }}</span
                >
              </td>
              <td>
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.l1InternalStatusName
                  }}"
                  >{{ rowData.l1InternalStatusName }}</span
                >
              </td>
              <td>
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.l2InternalStatusName
                  }}"
                  >{{ rowData.l2InternalStatusName }}</span
                >
              </td>
              @if (
                eventSearchType === invoiceDocReviewEventSearchType ||
                eventSearchType === rollCallReviewEventSearchType ||
                eventSearchType ===
                  skuPurchaseTrialActivationReviewEventSearchType ||
                eventSearchType === daPOEReviewEventSearchType ||
                eventSearchType === SOWReviewEventSearchType
              ) {
                <td>
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.eventRegistrationId }} : {{
                      getUploadedDate(rowData)
                    }}"
                    >{{ getUploadedDate(rowData) }}</span
                  >
                </td>
              }
              @if (eventSearchType === customerSurveyReviewEventSearchType) {
                <td>
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.eventRegistrationId }} : {{
                      rowData.submittedDate
                    }}"
                    >{{ rowData.submittedDate }}</span
                  >
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

@if (loadEditComponent) {
  <p-dialog
    id="engagementEdit"
    [transitionOptions]="'10ms'"
    [(visible)]="editNav"
    modal="true"
    showEffect="fade"
    [maximizable]="true"
    [style]="{ width: '90vw' }"
    (onHide)="onCloseEditModal()"
    [draggable]="false"
    [resizable]="false">
    <app-edit-event
      [eventRegistrationId]="eventEditInput.eventRegistrationId"
      [programTypeGUID]="programGuid"
      #editNavChild
      (showFullscreen)="onShowFullScreenChanged($event)"
      (closeEditSidebar)="onCloseEditModal()"></app-edit-event>
  </p-dialog>
}

@if (canShowEventPreviewModel) {
  <app-event-preview
    (reLoadList)="refresh()"
    [eventPreviewInput]="eventPreviewInput"
    (closePreviewModal)="closePreview()"></app-event-preview>
}

@if (canShowCustomerSurveyPreviewModel) {
  <app-customer-survey-preview
    (reLoadList)="refresh()"
    [customerSurveyPreviewInput]="customerSurveyPreviewInput"
    (closePreviewModal)="
      closeCustomerSurveyPreview()
    "></app-customer-survey-preview>
}

@if (canShowCustomerValidationPreviewModel) {
  <app-customer-validation-preview
    (reLoadList)="refresh()"
    [customerValidationPreviewInput]="customerValidationPreviewInput"
    (closePreviewModal)="
      closeCustomerValidationPreview()
    "></app-customer-validation-preview>
}
